import { FC } from "react";
import { PanelActions } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/ActionsOverflowMenu";
import { useConvertToReserveAction } from "features/CenterContent/VehicleDetails/BackupAlternativeTransportDetails/useConvertToReserveAction";
import { useEditBackupVehicleAction } from "features/CenterContent/VehicleDetails/BackupAlternativeTransportDetails/useEditBackupVehicleAction";
import { useTakeInUseOrReleaseBackupAction } from "features/CenterContent/VehicleDetails/BackupAlternativeTransportDetails/useTakeInUseOrReleaseBackupAction";
import { ReserveAlternativeTransport } from "shared/types/alternativeTransport";
import { isBackupFromPlan } from "shared/utils/alternativeTransport";

type Props = {
  vehicle: ReserveAlternativeTransport;
};

/**
 * Header actions for backup bus.
 */
export const BackupPanelActions: FC<Props> = ({ vehicle }) => {
  const isPlan = isBackupFromPlan(vehicle);

  const editAction = useEditBackupVehicleAction(vehicle);
  const convertToReserveAction = useConvertToReserveAction(vehicle);
  const takeInUseOrReleaseAction = useTakeInUseOrReleaseBackupAction(vehicle);

  const actions = [
    editAction,
    ...(isPlan ? [] : [convertToReserveAction]),
    takeInUseOrReleaseAction,
  ];

  return <PanelActions overflowActions={actions} inlineActions={actions} />;
};
